export class Electricity {
    account_number:string;
}
